import * as Yup from 'yup'

export const BGCManualUploadFormSchema = Yup.object().shape({
  bgcFile: Yup.string().required('Background check is required'),
})

export const BGCMVRManualUploadFormSchema = Yup.object().shape({
  bgcFile: Yup.string().required('Background check is required'),
  mvrFile: Yup.string().required('Motor vehicle record is required'),
})
